import { LoadingIndicator } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import React from 'react';
import { QuickVideosTable } from './QuickVideosTable';
import { IQuickVideo, QuickVideoSortKeys } from 'lib/api/quickVideo/types';
import { PaginationConstants } from 'lib/const/PaginationConstants';
import { EmptySearchResult } from './style';
import { Button } from 'react-covideo-common';
import { HiPlus } from 'react-icons/hi';
import { useHistory } from 'react-router';

type QuickVideosListProps = {
  isLoading: boolean;
  data: IQuickVideo[];
  count: number;
  page: number;
  onPaginationChange: ({
    page,
    size,
  }: {
    page: number;
    size: number;
  }) => Promise<void>;
  limit: number;
  searchQuery: string;
  order?: PaginationConstants;
  sortKey: QuickVideoSortKeys | null;
  onSortChange?: (
    sortKey: QuickVideoSortKeys,
    order: PaginationConstants
  ) => void;
};

export const QuickVideosList = ({
  isLoading,
  data,
  count,
  page,
  limit,
  searchQuery,
  sortKey,
  order,
  onPaginationChange,
  onSortChange,
}: QuickVideosListProps) => {
  const history = useHistory();

  return isLoading ? (
    <Flex height='300px'>
      <LoadingIndicator isLoading={isLoading} />
    </Flex>
  ) : !data.length ? (
    <EmptySearchResult>
      {!!searchQuery ? (
        <div>
          There is no quick video matching your search "{searchQuery}". Add one
          to reply to customers faster.
        </div>
      ) : (
        <div>
          No Quick Videos added yet. Add one to reply to customers faster.
        </div>
      )}
      <Button
        onClick={() => {
          history.push('/ai-configuration/quick-videos/new');
        }}
        text='Add Quick Video'
        icon={<HiPlus />}
      />
    </EmptySearchResult>
  ) : (
    <QuickVideosTable
      data={data}
      count={count}
      page={page}
      limit={limit}
      sortKey={sortKey}
      order={order}
      onPaginationChange={onPaginationChange}
      onSortChange={onSortChange}
    />
  );
};
